var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DetailedfulTransfer"},[_c('Cashier',{attrs:{"isJust":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }